// pages/RecuperarSenha.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../shared/form/Input";
import styles from "./RecuperarSenha.module.css";
import logo_speed_order from '../images/SpeedOrderLogoSVG.svg';
import { Mail, ShieldCheck, KeyRound, ArrowLeft, CheckCircle2 } from "lucide-react";

function RecuperarSenha() {
  const [email, setEmail] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState("");
  const navigate = useNavigate();

  const enviarEmailRecuperacao = async (e) => {
    e.preventDefault();
    setErro("");
    setEnviando(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/recuperar-senha`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setEnviado(true);
      } else {
        setErro(data.message || "Email não encontrado.");
      }
    } catch (error) {
      setErro("Erro de conexão. Tente novamente.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <main className={styles.page}>
      {/* Painel de marca — vira uma faixa compacta em telas estreitas */}
      <section className={styles.brandPanel}>
        <div className={styles.brandTexture} aria-hidden="true" />
        <div className={styles.brandGlowOne} aria-hidden="true" />
        <div className={styles.brandGlowTwo} aria-hidden="true" />

        <div className={styles.brandContent}>
          <div className={styles.brandBadge}>
            <img src={logo_speed_order} alt="" />
          </div>

          <h1 className={styles.brandHeadline}>
            Esqueceu a senha?<br />Vamos resolver em 3 passos.
          </h1>
          <p className={styles.brandSub}>
            É rápido e seguro. Em poucos minutos você volta a fazer
            seus pedidos normalmente.
          </p>

          <ol className={styles.brandSteps}>
            <li>
              <span className={styles.brandStepIcon}><Mail size={16} /></span>
              Informe o e-mail cadastrado na sua conta
            </li>
            <li>
              <span className={styles.brandStepIcon}><ShieldCheck size={16} /></span>
              Enviaremos um link seguro para redefinição
            </li>
            <li>
              <span className={styles.brandStepIcon}><KeyRound size={16} /></span>
              Crie uma nova senha e entre normalmente
            </li>
          </ol>
        </div>

        <button type="button" className={styles.brandBackLink} onClick={() => navigate("/home")}>
          <ArrowLeft size={15} /> Voltar para o login
        </button>
      </section>

      {/* Painel do formulário */}
      <section className={styles.formPanel}>
        <div className={styles.wrapper}>
          <img src={logo_speed_order} alt="Logo SpeedOrder" className={styles.mobileLogo} />

          {enviado ? (
            <div className={styles.confirmacao}>
              <div className={styles.confirmacaoIcone}>
                <CheckCircle2 size={30} />
              </div>
              <h2>E-mail enviado!</h2>
              <p className={styles.subtitle}>
                Verifique a caixa de entrada (e o spam) de <strong>{email}</strong> e
                siga o link para criar uma nova senha.
              </p>
              <button type="button" className={styles.btn} onClick={() => navigate("/home")}>
                Voltar para o Login
              </button>
            </div>
          ) : (
            <form onSubmit={enviarEmailRecuperacao} className={styles.form}>
              <div className={styles.iconWrapper}>
                <KeyRound size={26} className={styles.icon} />
              </div>
              <h2>Recuperar senha</h2>
              <p className={styles.subtitle}>Digite seu email abaixo para te ajudarmos a recuperar sua senha.</p>

              {erro && (
                <div className={styles.mensagemErro}>
                  {erro}
                </div>
              )}

              <div className={styles.inputGroup}>
                <Input
                  type="email"
                  text=""
                  name="email"
                  placeholder="Digite seu email"
                  handleOnChange={(e) => setEmail(e.target.value)}
                  icon="✉"
                />
              </div>

              <button type="submit" className={styles.btn} disabled={enviando}>
                {enviando ? "Enviando..." : "Enviar"}
              </button>

              <div className={styles.footer}>
                <button
                  type="button"
                  className={styles.backBtn}
                  onClick={() => navigate("/home")}
                >
                  Voltar para Login
                </button>
              </div>
            </form>
          )}
        </div>
      </section>
    </main>
  );
}

export default RecuperarSenha;
